import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";

import images from "../../Constant/images";
import LoginPage from "../../Pages/LoginPage";
import { handleSelectUser, } from "../../Redux/actions/auth";
import { auth } from "../../Utils/auth";

const LoginContainer = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const authReducer = useSelector((state) => state.auth);
  const [openCalendar, setOpenCalendar] = useState(false);
  const [formData, setFormData] = useState({ role: "instructor" });
  const [userType, setUserType] = useState([
    {
      id: 1,
      user: "Instructor",
      icon: images.instructor,
      isSelected: true,
    },
    {
      id: 2,
      user: "Student",
      icon: images.student,
      isSelected: false,
    },
  ]);
  const [authPage, setAuthPage] = useState({
    isLogin: true,
    isChecked: false,
    showPassword: false,
    showPassword2: false,
  });

  const closeModal = () => setOpenCalendar(false);
  const openModal = () => setOpenCalendar(true);


  const handleUser = (role) => {
    const updatedUserType = userType.map((item) => ({
      ...item,
      isSelected: item.id === role?.id,
    }));
    setUserType(updatedUserType);
    formUpdate("role", role?.user.toLowerCase());
  };

  const formUpdate = (key, value) => {

    setFormData((prev) => ({
      ...prev,
      [key]: value,
    }));
  };

  const handleAuthPage = (key, value, field) => {
    setAuthPage((prev) => ({
      ...prev,
      [key]: value,
    }));
  
  };

  useEffect(() => {
    let token = auth?.getToken();
    if (token) {
      navigate("/dashboard");
    } else {
      navigate("/");
    }
    if (authReducer?.signupSuccess) {
      setFormData({});
      setTimeout(() => {
        let obj = { role: "instructor" };
        setFormData(obj);
      }, 10);
      handleAuthPage("isLogin", true);
    }
  }, [authReducer]);

  return (
    <LoginPage
      auth={authReducer}
      userType={userType}
      formData={formData}
      authPage={authPage}
      handleUser={handleUser}
      formUpdate={formUpdate}
      handleAuthPage={handleAuthPage}
      handleCalendar={openModal}
      openCalendar={openCalendar}
      closeModal={closeModal}
    />
  );
};

export default LoginContainer;
